import routes from './routes';

export const linkResolver = function(doc){
  // Pretty URLs for known types
  if (doc.type === 'blog_post') return `${routes.journal}/${doc.uid}`;
  if (doc.type === 'service_page') return `${routes.initiatives}/${doc.uid}`;
  if (doc.type === 'standalone_page') {
    return `/${doc.uid}`;
  }
  // Fallback for other types, in case new custom types get created
  return "/doc/" + doc.id;
};

// Resolve a Prismic link field (or a plain string) to a usable URL string, or
// null when there is no destination. NEVER returns the raw link object, so the
// result is always safe to pass to a <Link>/<a>. Empty links — including
// relationships dropped when copying content between locales — resolve to null.
export const resolveLinkUrl = function(link){
  if (typeof link === 'string') return link || null;
  if (!link || typeof link !== 'object') return null;
  if (link.isBroken) return null;
  if (link.link_type === 'Document' && (link.uid || link.type)) return linkResolver(link);
  return link.url || null;
};